export default class ImageItem{
    id:number
    image_url:string
    constructor(data:any){
        this.id=data.id
        this.image_url=data.image_url
    }
}